/* @flow */

// Ref: https://martinfowler.com/articles/feature-toggles.html

// Experiment features
export const onboardingIntroAFeature = 'onboarding_intro_a';
export const marketPromptsFeature = 'market_prompts';
export const helpFeature = 'help';
export const githubProfileFeature = '18.11_github_profile';
export const manualAvailabilityFeature = '19.06_manual_availability';
export const lightThemeFeature = 'light_theme';
export const provideFeedbackSectionFeature =
  '22.05_show_provide_feedback_section';
export const userRecommendationFeature = 'user_recommendation';
export const fishbowlHotseat = 'fishbowl_hotseat';
export const fishbowlFeature = 'fishbowl';
export const groupMessageModalFeature = '22.02_group_message_modal';
export const interestBasedBraindatingFeature = 'interest_based_braindating';
export const trendingKeywordsSectionFeature = 'trending_section_market';
export const accessibilityCompatibleFeature = '22.10_accessibility_compatible';
export const topicRecommendationFeature = 'recommendation';
export const userOnboardingFeature = '23.02_user_onboarding';
// Integration features
export const disableLoginLinkFeature = 'disable_login_link';
export const hideAccountPrefsFeature = '18.10_hide_account_prefs';

// Plugins
export const emailPlugin = 'email';
export const smsPlugin = 'sms';
export const signupPlugin = 'signup';
export const selfCheckInPlugin = 'self_checkin';
export const slackPlugin = 'slack';
export const iframeIntegrationPlugin = 'iframe_integration';
export const topicDisclaimerPlugin = 'topic_disclaimer';
export const googleSyncPlugin = 'google-calendar';
export const outlookSyncPlugin = 'microsoft-outlook';
export const doubleDutchPlugin = 'doubledutch';
export const ssoPlugin = 'sso';
export const moderationPlugin = 'moderation';
export const klikPlugin = 'klik_profile';
export const customMenuPlugin = 'custom_menu';
export const videoCallPlugin = 'video-call';
export const videoCallPluginProviderTeams = 'microsoft-teams';
export const videoCallPluginProviderTwilio = 'twilio';
export const showcasePagePlugin = 'showcase_page';
export const sponsorshipPlugin = 'sponsorship';
export const customFontPlugin = 'custom_font';
export const customImpactSurvey = 'custom_impact_survey';
export const topicCardCustomizationPlugin = 'customized_topic_card';
export const conversationFormatsPlugin = 'braindate_format';
export const virtualBraindateRecordingPlugin = 'recordings';
export const redirectionPlugin = 'redirection';
export const expressionOfGratitudePlugin = 'gratitude';
export const transcribePlugin = 'transcribe';

// Sponsorship plugin levels
export const marketHeaderDesktopLevel = 'marketplace-card';
export const marketHeaderMobileLevel = 'marketplace-header';
export const marketFooterLevel = 'marketplace-footer';
export const loginSplashLevel = 'splash';
export const mainNavMenuLevel = 'navbar';
export const emailLevel = 'email';
export const videoCallLevel = 'video-call';
export const gratitudeModalLevel = 'gratitude-modal';

// Integration plugins
export const avatarUploadPlugin = '19.08_avatar_upload';
